import * as type from './type';
function getBlobBuilder() {
 if (typeof BlobBuilder !== 'undefined') {
 return BlobBuilder;
 }
 else if (typeof WebKitBlobBuilder !== 'undefined') {
 return WebKitBlobBuilder;
 }
 else {
 return undefined;
 }
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param var_args The values that will make up the resulting blob.
 * @return The blob.
 */
export function getBlob() {
 var var_args = [];
 for (var _i = 0; _i < arguments.length; _i++) {
 var_args[_i] = arguments[_i];
 }
 var BlobBuilder = getBlobBuilder();
 if (BlobBuilder !== undefined) {
 var bb = new BlobBuilder();
 for (var i = 0; i < var_args.length; i++) {
 bb.append(var_args[i]);
 }
 return bb.getBlob();
 }
 else {
 if (type.isNativeBlobDefined()) {
 return new Blob(var_args);
 }
 else {
 throw Error("This browser doesn't seem to support creating Blobs");
 }
 }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */
export function sliceBlob(blob, start, end) {
 if (blob.webkitSlice) {
 return blob.webkitSlice(start, end);
 }
 else if (blob.mozSlice) {
 return blob.mozSlice(start, end);
 }
 else if (blob.slice) {
 return blob.slice(start, end);
 }
 return null;
}

//# sourceMappingURL=fs.js.map



//////////////////
// WEBPACK FOOTER
// ../storage/dist/esm/src/implementation/fs.js
// module id = null
// module chunks = 